import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import ClientesList from '../components/clientes/ClientesList'
import ClienteDetails from '../components/clientes/ClienteDetails'
import Button from '../components/ui/Button'

const ClientesPage: React.FC = () => {
  const { clienteId } = useParams<{ clienteId: string }>()
  const navigate = useNavigate()
  const [selectedClienteId, setSelectedClienteId] = useState<number | null>(
    clienteId ? parseInt(clienteId) : null
  )

  const handleClienteSelect = (clienteId: number) => {
    setSelectedClienteId(clienteId)
    navigate(`/clientes/${clienteId}`)
  }

  const handleBackToList = () => {
    setSelectedClienteId(null)
    navigate('/clientes')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {selectedClienteId ? (
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <Button
                variant="ghost"
                size="sm"
                leftIcon={<ArrowLeft className="h-4 w-4" />}
                onClick={handleBackToList}
              >
                Voltar à Lista
              </Button>
            </div>
            
            <ClienteDetails
              clienteId={selectedClienteId}
              onEdit={() => {
                // Refresh page after edit
                window.location.reload()
              }}
            />
          </div>
        ) : (
          <ClientesList
            onClienteSelect={(cliente) => handleClienteSelect(cliente.id)}
          />
        )}
      </div>
    </div>
  )
}

export default ClientesPage